import {paddingLeft} from "@Common/utils/strings";

export const parseHexToColor = (hex) => {
    if (hex == null) {
        return null;
    }
    return {
        r: parseInt(hex.substring(1, 3), 16),
        g: parseInt(hex.substring(3, 5), 16),
        b: parseInt(hex.substring(5, 7), 16),
    };
};

export const formatColorToHex = (c) => {
    if (c == null) {
        return null;
    }
    const a = (v) => paddingLeft(v.toString(16));
    return (
        "#" +
        a(c.r).toUpperCase() +
        a(c.g).toUpperCase() +
        a(c.b).toUpperCase() +
        ""
    );
};